<template>
	<Modal @close="$emit('close')" size="small" class="upgrade-modal">
		<div class="container">
			<div class="row">
				<div class="col-12 text-center">
					<h3>No More Horses Available</h3>
					<div>
						<router-link to="/account">Upgrade Now</router-link>
					</div>
				</div>
			</div>
		</div>
	</Modal>
</template>

<script>
import Modal from './../Modal.vue'

export default {
	components: {
		Modal
	}
}
</script>

<style lang="scss">
.upgrade-modal {
	a, a:hover, a:focus, a:visited {
		color: #009487
	}
}
</style>


// WEBPACK FOOTER //
// src/components/Horses/Upgrade.vue